import { route, type PageTour } from '../pageTour';
import { alertBoardSteps } from './alertBoardSteps';

export const allSitesAlertBoardTour: PageTour = {
  id: 'page-all-sites-alert-board',
  version: 2,
  title: 'All Sites Alert Board',
  summary: 'Live alerts from every site in one board.',
  match: route('/all-sites/alert-board', '/all-sites/alert-board/gis', '/all-sites/alert-board/map'),
  steps: alertBoardSteps(true),
};
